// extracted by mini-css-extract-plugin
module.exports = {"container":"OtpInput_container__z7wXf"};